import React from "react";
import { Editor } from "slate";

export const onPaste = (editor: Editor) => (e: React.KeyboardEvent) => {
  e.preventDefault();
};
